import React from 'react';
import { Modal } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';

// Services
import GlobalStateService from 'services/GlobalStateService';
import InstructorService from 'services/InstructorService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class BookingNotesModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                instructorID: opts.id
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        this.setState({
            isLoading: true,
            bookingNotes: null
        });
        const bookingNotes = await InstructorService.getBookingNotes(this.state.instructorID);
        this.setState({
            isLoading: false,
            bookingNotes
        });
    }

    close() {
        this.setState({ isOpen: false });
    }
    
    async saveAndClose() {
        const { instructorID, bookingNotes } = this.state;
        this.setState({ isLoading: true });
        await InstructorService.saveBookingNotes(instructorID, bookingNotes);
        this.setState({ isLoading: false });
        this.close();
        this.resolve();
    }

    //------------------------------------------------------------------------------

    render() {
        const {
            isOpen,
            isLoading
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="booking-notes-modal">
                {isLoading ? <Modal.Body><Loader /></Modal.Body> : this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            bookingNotes
        } = this.state;

        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (<>
            <Modal.Body>

                <ExpandingTextArea
                    className="form-control"
                    defaultValue={bookingNotes || ''}
                    onBlur={e => this.setState({ bookingNotes: e.target.value })}
                    rows={4}
                    readOnly={!loginInfo.isAdmin}
                />
                
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary me-auto" onClick={e => this.close()}>
                    Cancel
                </button>
                <button type="button" className="btn btn-primary ms-auto" onClick={e => this.saveAndClose()}>
                    Save
                </button>
            </Modal.Footer>
        </>);
    }

}

export default BookingNotesModal;